import { useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { ContinueWithApple } from '~components/ContinueWithApple';
import { ContinueWithGoogle } from '~components/ContinueWithGoogle';
import { Login } from '~components/Login';
import type { AuthSession } from '~utils/auth';
import { styles } from './styles';
type Props = {
  onLogin: (session: AuthSession) => void;
};

// Composer, the web ContinueWithButtons: stacks every sign-in method the app
// offers (same order — Google, Apple, then credentials) and owns the shared
// error slot. Each method's logic lives in its own component.
export function LoginPanel({
  onLogin
}: Props) {
  const [error, setError] = useState<string | null>(null);
  return <div {...stylex.props(styles.panel)}>
      <div {...stylex.props(styles.providers)}>
        <ContinueWithGoogle onLogin={onLogin} onError={setError} />
        <ContinueWithApple onLogin={onLogin} onError={setError} />
      </div>
      <div {...stylex.props(styles.divider)}>
        <span {...stylex.props(styles.dividerLabel)}>or</span>
      </div>
      <Login onLogin={onLogin} onError={setError} />
      {error && <p {...stylex.props(styles.error)} role="alert">{error}</p>}
    </div>;
}